export class UnifiedRestoreMicrosoft365User {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "entityId",
            "baseName": "entityId",
            "type": "string",
            "format": ""
        },
        {
            "name": "exchange",
            "baseName": "exchange",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "oneDrive",
            "baseName": "oneDrive",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UnifiedRestoreMicrosoft365User.attributeTypeMap;
    }
    constructor() {
    }
}
